// Environment configuration utility
// This centralizes all environment variables and provides type-safe access

interface EnvConfig {
  // Supabase Configuration
  supabaseUrl: string;
  supabaseAnonKey: string;
  
  // Adzuna API Configuration
  azdunaApiUrl: string;
  azdunaAppId: string;
  azdunaAppKey: string;
  
  // Application Configuration
  appName: string;
  appVersion: string;
  nodeEnv: string;
  isProduction: boolean;
  isDevelopment: boolean;
  isTest: boolean;
  
  // API Configuration
  apiTimeout: number;
  apiUrl: string;
  
  // Analytics Configuration
  analyticsEnabled: boolean;
  enableAnalytics: boolean;
  analyticsProvider: string;
  googleAnalyticsId: string;
  
  // Feature Flags
  enableNotifications: boolean;
  
  // CDN Configuration
  cdnUrl: string;
  
  // Cache Configuration
  cacheTTL: number;
}

// Extract values from import.meta.env with fallbacks
const env: EnvConfig = {
  // Supabase Configuration
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || "https://vdsuwyneognslvsfgbdn.supabase.co",
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkc3V3eW5lb2duc2x2c2ZnYmRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4NTUyOTMsImV4cCI6MjA2MTQzMTI5M30.Ijvn49m3wmSXTWhOK-WCkCufT0Zr0Uk4qGP4_1Hs7_0",
  
  // Adzuna API Configuration
  azdunaApiUrl: import.meta.env.VITE_AZDUNA_API_URL || "https://api.adzuna.com/v1/api",
  azdunaAppId: import.meta.env.VITE_AZDUNA_APP_ID || "7fbb9163",
  azdunaAppKey: import.meta.env.VITE_AZDUNA_APP_KEY || "40bb88fb5d2e996e6734c95185569c87",
  
  // Application Configuration
  appName: import.meta.env.VITE_APP_NAME || "Salaari",
  appVersion: import.meta.env.VITE_APP_VERSION || "1.0.0",
  nodeEnv: import.meta.env.MODE || "development",
  isProduction: import.meta.env.PROD || false,
  isDevelopment: import.meta.env.DEV || true,
  isTest: import.meta.env.MODE === "test" || false,
  
  // API Configuration
  apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || "30000", 10),
  apiUrl: import.meta.env.VITE_API_URL || "/api",
  
  // Analytics Configuration
  analyticsEnabled: import.meta.env.VITE_ENABLE_ANALYTICS === "true" || import.meta.env.PROD || false,
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === "true" || import.meta.env.PROD || false,
  analyticsProvider: import.meta.env.VITE_ANALYTICS_PROVIDER || "google-analytics", // Changed default to google-analytics
  googleAnalyticsId: import.meta.env.VITE_GA_ID || "G-593QY7RRSR", // Added the Google Analytics ID
  
  // Feature Flags
  enableNotifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === "true" || false,
  
  // CDN Configuration
  cdnUrl: import.meta.env.VITE_CDN_URL || "",
  
  // Cache Configuration
  cacheTTL: parseInt(import.meta.env.VITE_CACHE_TTL || "3600", 10),
};

// Function to get image URL with CDN if configured
export const getImageUrl = (path: string): string => {
  if (!path) return "";
  
  // If path is already a full URL, return it as is
  if (path.startsWith('http')) return path;
  
  // If CDN is configured, use it for images
  if (env.cdnUrl && env.isProduction) {
    return `${env.cdnUrl}${path.startsWith('/') ? path : `/${path}`}`;
  }
  
  return path;
};

// Export the environment configuration
export default env;
